import './ActivityLabel.less';
import IconButton from "../IconButton/IconButton";
import Icons from "../IconButton/Icons";
import ActivityCategory from "../../entities/activityCategory";
import ActivityType from "../../entities/activityType";

function ActivityLabel(props: ActivityLabelProps){

    const deleted = props.deleted ? 'deleted' : '';
    const noCategory = props.category ? '' : 'no-category';
    const small = props.small ? 'small' : '';
    const name = props.typeNameOverride || props.type.name;

    return (
        <div className='activity-label'>
            {props.category && <div className='activity-label__category'>
				<IconButton type={Icons[props.category.icon]}
				            label={props.category.name}
				            size={props.small ? 'small' : 'normal'}
				            title={props.type.name}
				/>
			</div>
            }
            <div className={`activity-label__type ${noCategory} ${small}`}>
                <IconButton type={Icons[props.type.icon]}
                            label={<span className={deleted}>{name}</span>}
                            size={props.small ? 'small' : 'normal'}
                            title={props.type.name}
                />
            </div>
        </div>
    )

}

export type ActivityLabelProps = {
    // The (optional) ActivityCategory
    category?: ActivityCategory,

    // The ActivityType
    type: ActivityType,

    // Override activity type name
    typeNameOverride?: string,

    // Is this category/type deleted?
    deleted?: boolean,

    // Use small fonts?
    small?: boolean
};

export default ActivityLabel;
